export default "/signup/_next/static/chunks/fonts/lineto-circular-book-f71b4a1cf94a56be18a79c7a8a867f3c.woff2";